import { render } from "./AnswerPageEight.vue?vue&type=template&id=4dfa86a7&scoped=true"
import script from "./AnswerPageEight.vue?vue&type=script&lang=js"
export * from "./AnswerPageEight.vue?vue&type=script&lang=js"

import "./AnswerPageEight.vue?vue&type=style&index=0&id=4dfa86a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfa86a7"]])

export default __exports__